<adapt-activity-section-collapsible [section]="section"
                                    [count]="displayedCount"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    <div *ngIf="overdueObjectiveGroups?.length || upcomingObjectiveGroups?.length"
         class="d-flex flex-row flex-wrap gap-3">
        <adapt-universal-dashboard-element *ngIf="overdueObjectiveGroups && overdueObjectiveGroups.length > 0"
                                           name="Activities due"
                                           [background]="false"
                                           [nested]="true">
            <div class="objective-groups">
                <div *ngFor="let objectiveTeamGroup of overdueObjectiveGroups">
                    <adapt-link-objectives-page *adaptIfAlto="false"
                                                [team]="objectiveTeamGroup.team"
                                                class="objectives-team-label"></adapt-link-objectives-page>

                    <div class="d-flex flex-column objectives">
                        <adapt-objective-dashboard-summary *ngFor="let objective of objectiveTeamGroup.objectives"
                                                           [objective]="objective"
                                                           [displayAssignee]="false"
                                                           [class.overdue]="objective.isOverdue"></adapt-objective-dashboard-summary>
                    </div>
                </div>
            </div>
        </adapt-universal-dashboard-element>

        <adapt-universal-dashboard-element *ngIf="upcomingObjectiveGroups && upcomingObjectiveGroups.length > 0"
                                           name="Upcoming"
                                           [background]="false"
                                           [nested]="true">
            <div class="objective-groups">
                <div *ngFor="let objectiveTeamGroup of upcomingObjectiveGroups">
                    <adapt-link-objectives-page *adaptIfAlto="false"
                                                [team]="objectiveTeamGroup.team"
                                                class="objectives-team-label"></adapt-link-objectives-page>

                    <div class="d-flex flex-column objectives">
                        <adapt-objective-dashboard-summary *ngFor="let objective of objectiveTeamGroup.objectives"
                                                           [objective]="objective"
                                                           [displayAssignee]="false"
                                                           [class.overdue]="objective.isOverdue"></adapt-objective-dashboard-summary>
                    </div>
                </div>
            </div>
        </adapt-universal-dashboard-element>
    </div>
</adapt-activity-section-collapsible>
